import { trackAnalyticsEvent } from '@color/lib';
import { FC, PropsWithChildren, useEffect } from 'react';
import { Metric, onCLS, onFCP, onINP, onLCP, onTTFB } from 'web-vitals';

const onWebVitals = (metric: Metric) => {
  const { name, value, rating, id, navigationType } = metric;
  trackAnalyticsEvent('Web Vitals', {
    name,
    value,
    rating,
    id,
    navigationType,
    path: window.location.pathname,
    url: window.location.href,
  });
};

const initWebVitals = (): void => {
  onCLS(onWebVitals);
  onINP(onWebVitals);
  onLCP(onWebVitals);
  onFCP(onWebVitals);
  onTTFB(onWebVitals);
};

export const WebVitalsProvider: FC<PropsWithChildren> = (props) => {
  const { children } = props;
  // nosemgrep:semgrep-rules.ui-useEffect
  useEffect(() => {
    initWebVitals();
  }, []);
  return <>{children}</>;
};
